import { Product } from '../product/product';

export default class GroupedSkusView {
  childrenSKUs?: Array<Product>;
  mainSKU?: Product;
}
